(function () {
  var maximumScale = 3;
  var doubleTapScale = 2;
  var resetThreshold = 1.02;
  var resetDuration = 250;
  var doubleTapDelay = 300;
  var doubleTapTolerance = 30;

  var zoomState = {
    image: null,
    cell: null,
    slideshow: null,
    scale: 1,
    translateX: 0,
    translateY: 0,
    baseWidth: 0,
    baseHeight: 0
  };

  var gesture = null;
  var lastTap = { time: 0, x: 0, y: 0, cell: null };
  var tapCandidate = null;

  function distanceBetween(firstTouch, secondTouch) {
    var deltaX = secondTouch.clientX - firstTouch.clientX;
    var deltaY = secondTouch.clientY - firstTouch.clientY;
    return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
  }

  function midpointOf(firstTouch, secondTouch) {
    return {
      x: (firstTouch.clientX + secondTouch.clientX) / 2,
      y: (firstTouch.clientY + secondTouch.clientY) / 2
    };
  }

  function clamp(value, minimum, maximum) {
    return Math.min(Math.max(value, minimum), maximum);
  }

  function getFlickityInstance(slideshow) {
    if (!slideshow || typeof window.Flickity === 'undefined') {
      return null;
    }
    return window.Flickity.data(slideshow);
  }

  function setDraggable(slideshow, isDraggable) {
    var flickityInstance = getFlickityInstance(slideshow);
    if (!flickityInstance) {
      return;
    }
    flickityInstance.options.draggable = isDraggable;
    if (isDraggable) {
      if (typeof flickityInstance.bindDrag === 'function') {
        flickityInstance.bindDrag();
      }
    } else if (typeof flickityInstance.unbindDrag === 'function') {
      flickityInstance.unbindDrag();
    }
    if (typeof flickityInstance.updateDraggable === 'function') {
      flickityInstance.updateDraggable();
    }
  }

  function abortFlickityDrag(slideshow) {
    var flickityInstance = getFlickityInstance(slideshow);
    if (!flickityInstance) {
      return;
    }
    if (flickityInstance.isPointerDown && typeof flickityInstance._pointerDone === 'function') {
      flickityInstance._pointerDone();
    }
    if (typeof flickityInstance.select === 'function' && typeof flickityInstance.selectedIndex === 'number') {
      flickityInstance.select(flickityInstance.selectedIndex, false, true);
    }
  }

  function bindSlideChangeReset(slideshow) {
    var flickityInstance = getFlickityInstance(slideshow);
    if (!flickityInstance || flickityInstance.pinchZoomChangeBound) {
      return;
    }
    flickityInstance.pinchZoomChangeBound = true;
    flickityInstance.on('change', function () {
      if (zoomState.image && zoomState.slideshow === slideshow) {
        hardResetZoom();
      }
    });
  }

  function applyTransform(withTransition) {
    if (!zoomState.image) {
      return;
    }
    zoomState.image.style.transition = withTransition
      ? 'transform ' + resetDuration + 'ms ease-out'
      : 'none';
    zoomState.image.style.transform =
      'translate(' + zoomState.translateX + 'px, ' + zoomState.translateY + 'px) scale(' + zoomState.scale + ')';
  }

  function clampTranslate() {
    var maximumX = Math.max(0, (zoomState.scale - 1) * zoomState.baseWidth / 2);
    var maximumY = Math.max(0, (zoomState.scale - 1) * zoomState.baseHeight / 2);
    zoomState.translateX = clamp(zoomState.translateX, -maximumX, maximumX);
    zoomState.translateY = clamp(zoomState.translateY, -maximumY, maximumY);
  }

  function targetZoom(cell, image, slideshow) {
    if (zoomState.image && zoomState.image !== image) {
      hardResetZoom();
    }
    zoomState.image = image;
    zoomState.cell = cell;
    zoomState.slideshow = slideshow;
  }

  function enterZoom() {
    zoomState.cell.classList.add('is-pinch-zooming');
    zoomState.image.style.willChange = 'transform';
    zoomState.image.style.transformOrigin = 'center center';
    setDraggable(zoomState.slideshow, false);
    bindSlideChangeReset(zoomState.slideshow);
  }

  function clearZoomState() {
    zoomState.image = null;
    zoomState.cell = null;
    zoomState.slideshow = null;
    zoomState.scale = 1;
    zoomState.translateX = 0;
    zoomState.translateY = 0;
    zoomState.baseWidth = 0;
    zoomState.baseHeight = 0;
  }

  function resetZoom() {
    if (!zoomState.image) {
      return;
    }

    var image = zoomState.image;
    var cell = zoomState.cell;
    var slideshow = zoomState.slideshow;

    zoomState.scale = 1;
    zoomState.translateX = 0;
    zoomState.translateY = 0;
    applyTransform(true);

    setDraggable(slideshow, true);

    window.setTimeout(function () {
      image.style.transition = '';
      image.style.transform = '';
      image.style.transformOrigin = '';
      image.style.willChange = '';
      cell.classList.remove('is-pinch-zooming');
    }, resetDuration);

    gesture = null;
    clearZoomState();
  }

  function hardResetZoom() {
    if (!zoomState.image) {
      return;
    }
    var image = zoomState.image;
    var cell = zoomState.cell;
    var slideshow = zoomState.slideshow;

    image.style.transition = '';
    image.style.transform = '';
    image.style.transformOrigin = '';
    image.style.willChange = '';
    cell.classList.remove('is-pinch-zooming');
    setDraggable(slideshow, true);

    gesture = null;
    clearZoomState();
  }

  function captureBaseMetrics(image) {
    var imageBounds = image.getBoundingClientRect();
    zoomState.baseWidth = imageBounds.width / zoomState.scale;
    zoomState.baseHeight = imageBounds.height / zoomState.scale;
    return {
      centerX: imageBounds.left + imageBounds.width / 2 - zoomState.translateX,
      centerY: imageBounds.top + imageBounds.height / 2 - zoomState.translateY
    };
  }

  function beginPinch(cell, image, slideshow, touches) {
    targetZoom(cell, image, slideshow);
    if (zoomState.scale === 1) {
      enterZoom();
    }
    abortFlickityDrag(slideshow);

    var elementCenter = captureBaseMetrics(image);
    var startMidpoint = midpointOf(touches[0], touches[1]);

    gesture = {
      type: 'pinch',
      startDistance: distanceBetween(touches[0], touches[1]),
      startMidpoint: startMidpoint,
      startScale: zoomState.scale,
      startTranslateX: zoomState.translateX,
      startTranslateY: zoomState.translateY,
      elementCenterX: elementCenter.centerX,
      elementCenterY: elementCenter.centerY
    };
  }

  function beginPan(touch) {
    gesture = {
      type: 'pan',
      startX: touch.clientX,
      startY: touch.clientY,
      startTranslateX: zoomState.translateX,
      startTranslateY: zoomState.translateY
    };
  }

  function toggleDoubleTapZoom(cell, image, slideshow, tapX, tapY) {
    if (zoomState.image && zoomState.scale > 1) {
      resetZoom();
      return;
    }

    targetZoom(cell, image, slideshow);
    enterZoom();

    var elementCenter = captureBaseMetrics(image);
    zoomState.scale = doubleTapScale;
    zoomState.translateX = (1 - doubleTapScale) * (tapX - elementCenter.centerX);
    zoomState.translateY = (1 - doubleTapScale) * (tapY - elementCenter.centerY);
    clampTranslate();
    applyTransform(true);
  }

  function onTouchStart(event) {
    var slideshow = event.target.closest('.Product__Slideshow');
    var cell = event.target.closest('.Product__SlideItem--image');
    var image = cell ? cell.querySelector('img') : null;

    if (event.touches.length === 2) {
      var flickityInstance = getFlickityInstance(slideshow);
      if (!flickityInstance || !flickityInstance.isActive || !cell || !image) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      tapCandidate = null;
      beginPinch(cell, image, slideshow, event.touches);
      return;
    }

    if (event.touches.length === 1) {
      if (zoomState.image && zoomState.scale > 1 && slideshow === zoomState.slideshow) {
        event.preventDefault();
        event.stopPropagation();
        setDraggable(zoomState.slideshow, false);
        abortFlickityDrag(zoomState.slideshow);
        beginPan(event.touches[0]);
        tapCandidate = {
          x: event.touches[0].clientX,
          y: event.touches[0].clientY,
          cell: zoomState.cell,
          image: zoomState.image,
          slideshow: zoomState.slideshow
        };
        return;
      }

      var flickityForTap = getFlickityInstance(slideshow);
      if (flickityForTap && flickityForTap.isActive && cell && image) {
        tapCandidate = {
          x: event.touches[0].clientX,
          y: event.touches[0].clientY,
          cell: cell,
          image: image,
          slideshow: slideshow
        };
      } else {
        tapCandidate = null;
      }
    }
  }

  function onTouchMove(event) {
    if (zoomState.image && zoomState.scale > 1) {
      var moveSlideshow = event.target.closest('.Product__Slideshow');
      if (moveSlideshow && moveSlideshow === zoomState.slideshow) {
        event.stopPropagation();
      }
    }

    if (tapCandidate && event.touches.length === 1) {
      var movedX = Math.abs(event.touches[0].clientX - tapCandidate.x);
      var movedY = Math.abs(event.touches[0].clientY - tapCandidate.y);
      if (movedX > doubleTapTolerance || movedY > doubleTapTolerance) {
        tapCandidate = null;
      }
    }

    if (!gesture) {
      return;
    }

    if (gesture.type === 'pinch') {
      if (event.touches.length < 2) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();

      var currentDistance = distanceBetween(event.touches[0], event.touches[1]);
      var newScale = clamp(gesture.startScale * (currentDistance / gesture.startDistance), 1, maximumScale);
      var currentMidpoint = midpointOf(event.touches[0], event.touches[1]);

      var focalX = (gesture.startMidpoint.x - gesture.elementCenterX - gesture.startTranslateX) / gesture.startScale;
      var focalY = (gesture.startMidpoint.y - gesture.elementCenterY - gesture.startTranslateY) / gesture.startScale;

      zoomState.scale = newScale;
      zoomState.translateX = currentMidpoint.x - gesture.elementCenterX - newScale * focalX;
      zoomState.translateY = currentMidpoint.y - gesture.elementCenterY - newScale * focalY;
      clampTranslate();
      applyTransform(false);
      return;
    }

    if (gesture.type === 'pan') {
      if (event.touches.length !== 1) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      zoomState.translateX = gesture.startTranslateX + (event.touches[0].clientX - gesture.startX);
      zoomState.translateY = gesture.startTranslateY + (event.touches[0].clientY - gesture.startY);
      clampTranslate();
      applyTransform(false);
    }
  }

  function evaluateTap(event) {
    if (!tapCandidate) {
      return;
    }
    var candidate = tapCandidate;
    tapCandidate = null;

    var now = event.timeStamp;
    var isDoubleTap =
      lastTap.cell === candidate.cell &&
      now - lastTap.time < doubleTapDelay &&
      Math.abs(candidate.x - lastTap.x) < doubleTapTolerance &&
      Math.abs(candidate.y - lastTap.y) < doubleTapTolerance;

    if (isDoubleTap) {
      event.preventDefault();
      lastTap.time = 0;
      lastTap.cell = null;
      toggleDoubleTapZoom(candidate.cell, candidate.image, candidate.slideshow, candidate.x, candidate.y);
    } else {
      lastTap.time = now;
      lastTap.x = candidate.x;
      lastTap.y = candidate.y;
      lastTap.cell = candidate.cell;
    }
  }

  function onTouchEnd(event) {
    if (gesture && gesture.type === 'pinch') {
      if (event.touches.length >= 2) {
        return;
      }
      if (zoomState.scale <= resetThreshold) {
        resetZoom();
      } else if (event.touches.length === 1) {
        beginPan(event.touches[0]);
      } else {
        gesture = null;
      }
      return;
    }

    if (gesture && gesture.type === 'pan') {
      if (event.touches.length === 0) {
        gesture = null;
        evaluateTap(event);
      }
      return;
    }

    if (event.touches.length === 0) {
      evaluateTap(event);
    }
  }

  document.addEventListener('touchstart', onTouchStart, { passive: false, capture: true });
  document.addEventListener('touchmove', onTouchMove, { passive: false, capture: true });
  document.addEventListener('touchend', onTouchEnd, { passive: false, capture: true });
  document.addEventListener('touchcancel', onTouchEnd, { passive: false, capture: true });
})();
